// Studyo Today Backend
// Package studyo.today.item_duplication.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/item_duplication/v1/resources/distribution_duplication_details.proto (package studyo.today.item_duplication.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_item_duplication_v1_resources_item_distribution_pattern_kind } from "./item_distribution_pattern_kind_pb.js";

/**
 * Describes the file studyo/today/item_duplication/v1/resources/distribution_duplication_details.proto.
 */
export const file_studyo_today_item_duplication_v1_resources_distribution_duplication_details = /*@__PURE__*/
  fileDesc("ClFzdHVkeW8vdG9kYXkvaXRlbV9kdXBsaWNhdGlvbi92MS9yZXNvdXJjZXMvZGlzdHJpYnV0aW9uX2R1cGxpY2F0aW9uX2RldGFpbHMucHJvdG8SKnN0dWR5by50b2RheS5pdGVtX2R1cGxpY2F0aW9uLnYxLnJlc291cmNlcyJ/Ch5EaXN0cmlidXRpb25EdXBsaWNhdGlvbkRldGFpbHMSXQoMcGF0dGVybl9raW5kGAEgASgOMkcuc3R1ZHlvLnRvZGF5Lml0ZW1fZHVwbGljYXRpb24udjEucmVzb3VyY2VzLkl0ZW1EaXN0cmlidXRpb25QYXR0ZXJuS2luZEIxqgIuU3R1ZHlvLlRvZGF5Lkl0ZW1EdXBsaWNhdGlvbi5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_studyo_today_item_duplication_v1_resources_item_distribution_pattern_kind]);

/**
 * Describes the message studyo.today.item_duplication.v1.resources.DistributionDuplicationDetails.
 * Use `create(DistributionDuplicationDetailsSchema)` to create a new message.
 */
export const DistributionDuplicationDetailsSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_item_duplication_v1_resources_distribution_duplication_details, 0);

